import React from "react";
import {AOperation} from "../models/operations/AOperation";
import {EOperationType} from "../models/utils/EOperationType";
import {InstallationElement} from "../models/operations/InstallationElement";
import {Geolocate} from "../models/operations/Geolocate";
import {InstallationEquipment} from "../models/operations/InstallationEquipment";
import {UninstallElement} from "../models/operations/UninstallElement";
import {ReplaceElement} from "../models/operations/ReplaceElement";
import UninstallEquipment from "../models/operations/UninstallEquipment";
import DisplayElementInstallation from "../components/display/operation/DisplayElementInstallation";
import DisplayGeolocate from "../components/display/operation/DisplayGeolocate";
import DisplayUninstallationElement from "../components/display/operation/DisplayUninstallationElement";
import DisplayReplacementElement from "../components/display/operation/DisplayReplacementElement";
import DisplayEquipmentUninstallation from "../components/display/operation/DisplayEquipmentUninstallation";
import DisplayEquipmentInstallation from "../components/display/operation/DisplayEquipmentInstallation";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 31/05/2022
 * @last_update 31/05/2022
 **/
class DisplayOperationAccordingToTypeService {

   public generatesOperationDisplayElementsAccordingToThisType(operation: AOperation) {
       let display: React.ReactNode = "";
       switch (operation.type) {
           case EOperationType.InstallationElement:
               display = <DisplayElementInstallation operation={operation as InstallationElement}/>;
               break;
           case EOperationType.Geolocate:
               display = <DisplayGeolocate operation={operation as Geolocate}/>;
               break;
           case EOperationType.InstallationEquipment:
               display = <DisplayEquipmentInstallation operation={operation as InstallationEquipment}/>;
               break;
           case EOperationType.UninstallationElement:
               display = <DisplayUninstallationElement operation={operation as UninstallElement}/>;
               break;
           case EOperationType.ReplacementElement:
               display = <DisplayReplacementElement operation={operation as ReplaceElement}/>;
               break;
           case EOperationType.UninstallationEquipment:
               display = <DisplayEquipmentUninstallation operation={operation as UninstallEquipment}/>;
               break;
           default:
               // Nothing to do
               break;
       }
       return display;
   }

}

export default new DisplayOperationAccordingToTypeService();
